import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxPopupNotificationData } from "./bfx-popup-notification-data.model";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { BfxBlotterOrdersContextMenuItemAcceptanceState } from "shared/cubiq-services";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";

export class BfxPopupAcceptanceModifyOutNotificationData extends BfxPopupNotificationData {
  public acceptanceState: BfxBlotterOrdersContextMenuItemAcceptanceState;

  constructor(
    private activeUser: CubiqServices.ActiveUser,
    private hasAccept: boolean,
    private hasReject: boolean,
    private hasUnrestricted: boolean,
  ) {
    super(
      BFXNotificationType.ACCEPTANCE_NEEDED,
      "icon-edit",
      BFXNotificationSubType.ACCEPTANCE_MODIFY_OUT,
    );
    this.acceptanceState = new BfxBlotterOrdersContextMenuItemAcceptanceState();
    this.acceptanceState.actionRequests = {
      accept: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      acceptInto: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
      reject: {
        acceptance: new Map<CubiqTS.AcceptanceType, string[]>(),
        xfer: new Map<string, string[]>(),
      },
    };
  }

  reInitMaps() {
    this.acceptanceState.actionRequests.accept.acceptance.clear();
    this.acceptanceState.actionRequests.accept.xfer.clear();
    this.acceptanceState.actionRequests.acceptInto.acceptance.clear();
    this.acceptanceState.actionRequests.acceptInto.xfer.clear();
    this.acceptanceState.actionRequests.reject.acceptance.clear();
    this.acceptanceState.actionRequests.reject.xfer.clear();
  }

  private addToAcceptMap(orderId: string) {
    if (
      !this.acceptanceState.actionRequests.accept.acceptance.has(
        CubiqTS.AcceptanceType.MODIFICATION,
      )
    ) {
      this.acceptanceState.actionRequests.accept.acceptance.set(
        CubiqTS.AcceptanceType.MODIFICATION,
        [],
      );
    }
    this.acceptanceState.actionRequests.accept.acceptance
      .get(CubiqTS.AcceptanceType.MODIFICATION)
      .push(orderId);
  }
  private addToAcceptIntoMap(orderId: string) {
    if (
      !this.acceptanceState.actionRequests.acceptInto.acceptance.has(
        CubiqTS.AcceptanceType.MODIFICATION,
      )
    ) {
      this.acceptanceState.actionRequests.acceptInto.acceptance.set(
        CubiqTS.AcceptanceType.MODIFICATION,
        [],
      );
    }
    this.acceptanceState.actionRequests.acceptInto.acceptance
      .get(CubiqTS.AcceptanceType.MODIFICATION)
      .push(orderId);
  }
  private addToRejectMap(orderId: string) {
    if (
      !this.acceptanceState.actionRequests.reject.acceptance.has(
        CubiqTS.AcceptanceType.MODIFICATION,
      )
    ) {
      this.acceptanceState.actionRequests.reject.acceptance.set(
        CubiqTS.AcceptanceType.MODIFICATION,
        [],
      );
    }
    this.acceptanceState.actionRequests.reject.acceptance
      .get(CubiqTS.AcceptanceType.MODIFICATION)
      .push(orderId);
  }

  protected updateAllowableActions() {
    this.actions = [];
    this.reInitMaps();
    if (
      this.hasUnrestricted ||
      (this.activeUser.userTypeId === CubiqTS.UserType.TRADER && (this.hasAccept || this.hasReject))
    ) {
      let acceptCount: number = 0;
      let acceptIntoCount: number = 0;
      let rejectCount: number = 0;

      this.payload.forEach((item) => {
        if (this.hasUnrestricted || this.hasAccept || this.hasReject) {
          if (item.as_fv_deskId !== "-1") {
            //default trader group, needs accept into
            if (
              this.hasUnrestricted ||
              this.activeUser.tradingGroupsIds.indexOf(item.as_fv_deskId) > -1
            ) {
              if (this.hasUnrestricted || this.hasAccept) {
                acceptCount++;
                this.addToAcceptMap(item.orderId);
              }
              if (this.hasUnrestricted || this.hasReject) {
                rejectCount++;
                this.addToRejectMap(item.orderId);
              }
            }
          } else {
            // NOTE: Dont think this flow is possible in modify
            if (
              this.activeUser.userTypeId === CubiqTS.UserType.TRADER &&
              (this.hasUnrestricted || this.hasAccept)
            ) {
              this.addToAcceptIntoMap(item.orderId);
              acceptIntoCount++;
            }
            if (this.hasUnrestricted || this.hasReject) {
              this.addToRejectMap(item.orderId);
              rejectCount++;
            }
          }
        }
      });

      if (acceptCount == this.payload.length) {
        this.actions.push({
          label: "Accept",
          command: BfxPopupNotificationCommand.POPUP_DI_ACCEPT,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (acceptIntoCount == this.payload.length) {
        this.actions.push({
          label: "Accept Into",
          command: BfxPopupNotificationCommand.POPUP_DI_ACCEPT_INTO,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (rejectCount == this.payload.length) {
        this.actions.push({
          label: "Reject",
          command: BfxPopupNotificationCommand.POPUP_DI_REJECT,
          icon: "fa icon-menu-error bfx-context-menu-icon",
          styleClass: "bfx-context-menu-item-enabled",
          separatorBefore: this.actions.length > 0,
        });
      }
    }
  }

  destroy() {
    super.destroy();
    this.activeUser = null;
  }
}
